<script setup lang="ts">
defineProps<{ yes?: stringI18n; no?: stringI18n }>()
const t2 = useT2({ No: 'Ne', Yes: 'Taip' })
</script>

<template>
  <span :class="$style.switch">
    <span :class="$style.one2"><span :class="$style.one" /></span>
    <span :class="$style.two"
      ><span :class="$style.no">{{ no ?? t2('No') }}</span
      ><span :class="$style.yes">{{ yes ?? t2('Yes') }}</span></span
    >
  </span>
</template>

<style module>
.switch {
  composes: global(_relative);
  composes: global(_br99);
  composes: global(_row);
  composes: global(_fw-xl);
  composes: global(_fs09);
  composes: global(_ls-xs);
  composes: global(_hidden);
  composes: global(_noflex);
  composes: global(_inline);

  composes: global(_noselect);
  place-items: center;
  width: max-content;

  --h2: 26px;
  --h: calc(var(--h2) - 2px);
  background: var(--black-4);
  background: hsl(240deg 5% 40%);

  align-self: center;

  height: var(--h2);
}
.one2 {
  composes: global(_absolute);
  composes: global(_inset);
  transition: 150ms transform var(--tran2);
}
.one {
  composes: global(_br99);
  composes: global(_block);
  composes: global(_bg0);
  composes: global(_a1);
  width: var(--h);
  height: var(--h);
  margin: 1px;
}
.two {
  composes: global(_relative);
  composes: global(_grid);
  composes: global(_fs08);
  composes: global(_ls-xs);
  composes: global(_fw-xxl);
  composes: global(_txt_ctr);
  composes: global(_noflex);

  transition: 150ms transform var(--tran2);
  composes: global(_c0);
  padding: 0 6px 0 calc(var(--h) + 8px);
  --yes: 0;
  --no: 0.99;
  font-variant: tabular-nums;
  font-family: monospace;
}
.no,
.yes {
  transition: 150ms opacity var(--tran2);
  grid-column-start: 1;
  grid-row-start: 1;
}
.yes {
  opacity: var(--yes);
}
.no {
  opacity: var(--no);
}

:global(.IconSwitch.on) .switch {
  background: var(--blue2);
}

:global(.IconSwitch.on) .one2,
:global(.d) :global(.IconSwitch):hover .one2 {
  transform: translateX(calc(100% - var(--h) - 2px));
}
:global(.IconSwitch.on) .two,
:global(.d) :global(.IconSwitch):hover .two {
  transform: translateX(calc(0px - var(--h)));
  --yes: 1;
  --no: 0;
}

:global(.d) :global(.IconSwitch):not(:global(.on)):hover .two {
  transform: translateX(calc(-2px - var(--h)));
  --yes: 0.5;
  --no: 0;
}
</style>
